import { createFileRoute } from "@tanstack/react-router";
import { reviews } from "@/lib/site-config";
import { ReviewCard } from "@/components/ReviewCard";
import { CTABlock } from "@/components/CTABlock";
import { GoogleReviewsBadge } from "@/components/GoogleReviewsBadge";
import { Star } from "lucide-react";
import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/reviews")({
  head: () => seoHead({
    path: "/reviews",
    title: "Customer Reviews | Woodseer Autos | East London Garage",
    description: "See what local drivers say about Woodseer Autos. 4.4 stars on Google. Honest, reliable mechanics trusted across E14, Poplar, Canary Wharf and Tower Hamlets.",
    breadcrumbs: [
      { name: "Home", path: "/" },
      { name: "Reviews", path: "/reviews" },
    ],
  }),
  component: ReviewsPage,
});

function ReviewsPage() {
  return (
    <>
      <section className="section-y">
        <div className="mx-auto max-w-4xl px-4 md:px-6 text-center">
          <p className="eyebrow">Customer voice</p>
          <h1 className="mt-4 display-xl text-foreground">What local drivers say about us.</h1>
          <div className="mt-6 flex items-center justify-center gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="h-6 w-6 fill-[#FBBC04] text-[#FBBC04]" />
            ))}
          </div>
          <p className="mt-5 text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            Don't just take our word for it — here's what East London drivers have to say after bringing their vehicles to Woodseer Autos.
          </p>
          <div className="mt-7 flex justify-center">
            <GoogleReviewsBadge />
          </div>
        </div>
      </section>

      <section className="pb-20 md:pb-24">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {reviews.map((r, i) => (
              <ReviewCard key={i} review={r} featured={i === 0} />
            ))}
          </div>
        </div>
      </section>

      <CTABlock
        headline="Had a great experience with us?"
        subtext="We'd love to hear from you. And if you need your vehicle looked at, we're just a call away."
      />
    </>
  );
}
